import React from 'react';
import { ArrowRight } from 'lucide-react';
import { Link } from 'react-router-dom';
import { SEO } from '../components/SEO';
import { OrgChart } from '../components/OrgChart';

export const Home = () => {
  return (
    <>
      <SEO title="Accueil" />
      <div>
        {/* Hero Section with Background Image */}
        <section 
          className="relative min-h-[80vh] flex items-center justify-center bg-cover bg-center"
          style={{
            backgroundImage: `url('https://images.unsplash.com/photo-1507842217343-583bb7270b66?ixlib=rb-1.2.1&auto=format&fit=crop&w=2000&q=80')`,
          }}
        >
          <div className="absolute inset-0 bg-gradient-to-r from-primary-950/90 to-primary-900/80 mix-blend-multiply" />
          <div className="relative max-w-7xl mx-auto px-4 py-24 sm:px-6 lg:px-8 w-full">
            <div className="flex flex-col items-start">
              <img
                src="https://i.imgur.com/XxYajsA.jpeg"
                alt="Cercle Poincaré Logo"
                className="w-48 h-48 mb-8 bg-white rounded-lg p-3 -mt-12"
              />
              <div className="w-full text-center">
                <h1 className="text-4xl font-bold sm:text-5xl md:text-6xl text-white mb-6">
                  CERCLE POINCARÉ
                </h1>
                <p className="mt-6 text-xl text-primary-100 max-w-3xl mx-auto">
                  Un espace d'ouverture, de dialogue et d'intelligence collective au coeur de la Région GRAND EST
                </p>
                <div className="mt-10">
                  <Link
                    to="/evenements"
                    className="inline-flex items-center px-8 py-3 border-2 border-white text-base font-medium rounded-md text-white hover:bg-white hover:text-primary-900 transition-all duration-300"
                  >
                    Découvrir nos événements
                    <ArrowRight className="ml-2 h-5 w-5" />
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Latest Event Section */}
        <section className="py-16 bg-white">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <h2 className="text-3xl font-bold text-center mb-12">DERNIER ÉVÉNEMENT</h2>
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-start">
              <div className="aspect-video rounded-xl overflow-hidden">
                <img
                  src="https://i.imgur.com/FW1GJXu.jpeg"
                  alt="Elsa Zylberstein au Cercle Poincaré"
                  className="w-full h-full object-cover"
                />
              </div>
              <div>
                <h3 className="text-2xl font-bold mb-6">Elsa Zylberstein au Cercle Poincaré</h3>
                <div className="prose prose-lg">
                  <p className="mb-4">
                    Nous avons eu l'immense honneur d'accueillir Elsa Zylberstein au Cercle Poincaré pour un moment émouvant et sincère.
                  </p>
                  <p className="mb-4">
                    L'actrice est revenue sur son parcours exceptionnel, sur l'intense travail d'incarnation de Simone Veil dans le film Simone, le voyage du siècle, ainsi que sur les raisons profondes de son attachement à la ville de Nancy.
                  </p>
                  <p>
                    Son témoignage, empreint de sensibilité et de passion, a profondément touché les membres du Cercle, offrant un échange d'une rare intensité.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* About Section */}
        <section className="py-16">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="max-w-3xl mx-auto text-center">
              <h2 className="text-3xl font-bold mb-6">Notre Mission</h2>
              <p className="text-gray-600 text-lg mb-6">
                Inspiré par l'esprit novateur de l'École de Nancy, le Cercle Poincaré rassemble une centaine de membres issus de domaines variés, tous reconnus pour leur expertise et leur engagement envers des valeurs profondément humanistes.
              </p>
              <p className="text-gray-600 text-lg mb-6">
                Notre mission est de valoriser le potentiel exceptionnel de la région du Grand Est, qualifiée de "terre d'accueil et d'intelligence collective", tout en tissant des liens solides entre les sphères académiques, économiques et culturelles.
              </p>
              <Link
                to="/devenir-membre"
                className="inline-flex items-center text-primary-600 hover:text-primary-700"
              >
                Je deviens membre
                <ArrowRight className="ml-2 h-5 w-5" />
              </Link>
            </div>
          </div>
        </section>

        {/* Team Section */}
        <section className="py-16 bg-gray-50">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="text-center mb-12">
              <h2 className="text-3xl font-bold mb-6">Notre Équipe</h2>
            </div>
            <OrgChart />
          </div>
        </section>
      </div>
    </>
  );
};